import { useMutation, useQueryClient } from '@tanstack/react-query'
import axios from 'axios'
import { toast } from 'react-toastify'
import { QUERY_KEY_DIRECTOR } from './useApiGetDirectorMessage'
import { GLOBAL_ERROR } from '../../constants/translations/error'
import { useTranslation } from 'react-i18next'

export const useApiDeleteDirectorMessage = (storeId: number) => {
  const { t } = useTranslation()
  const queryClient = useQueryClient()
  const directorWordEndpoint = `/dir_message/${storeId}`
  return useMutation({
    mutationFn: () => axios.delete(directorWordEndpoint).then(response => response.data),
    onSuccess: () => {
      toast.info(t('pilotable.data_saved'))
      void queryClient.invalidateQueries({ queryKey: [QUERY_KEY_DIRECTOR, directorWordEndpoint] })
    },
    onError: () => {
      toast.error(t(GLOBAL_ERROR))
    }
  })
}
